import { httpCreate } from './http';

const http = httpCreate('/um/comment');

export const umComment = {
	getList(params, data) {
		return http.get(`/list`, { params, data });
	},
};
